<template>
    <ProLink
        class="insight-quicklink"
        :aria-label="`${article.title} – ${article.category.title} – posted on: ${formatMonthDayYear(article.display_date)}`"
        :to="{ name: 'insight-year-slug', params: { year: formatYear(article.display_date), slug: article.slug } }"
        :title="`${article.category.title} - ${article.title}`"
    >
        <div
            class="insight-quicklink__article-image"
            aria-hidden="true"
            :style="{
                backgroundImage: `url('https://optimised.savage.si/format:jpg,width:500/${article.image}')`,
                backgroundColor: article.cover_hex,
                color: `${article.cover_hex}40`,
            }"
        ></div>
        <div class="insight-quicklink__article-copy" aria-hidden="true">
            <div class="insight-quicklink__article-meta">
                <span :style="{ color: article.category.hex }">{{ article.category.title }}</span>
                <span>{{ formatMonthDayYear(article.display_date) }}</span>
            </div>
            <div class="insight-quicklink__article-title text-heading text-heading--xxs">
                {{ article.title }}
            </div>
        </div>
    </ProLink>
</template>

<script>
import { parseISO, format } from "date-fns";

export default {
    props: {
        article: Object,
    },

    methods: {
        formatMonthDayYear(date) {
            return format(parseISO(date), "MMM d',' yyyy");
        },

        formatYear(date) {
            return parseISO(date).getFullYear();
        },
    },
};
</script>
